import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Notify from '../../components/notify';
import Loader from '../../components/loader';
import { getGlobalSettingsAPI, updateGlobalSettingsAPI } from '../../services/api';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

const GlobalSettings = () => {
  const [openNotify, setOpenNotify] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [globalSettings, setGlobalSettings] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getGlobalSettings();
  }, []);

  const getGlobalSettings = async () => {
    try {
      setLoading(true);
      const response = await getGlobalSettingsAPI();
      setGlobalSettings(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setErrors(err);
      setOpenNotify(true);
    }
  };

  const updateGlobalSetting = (e) => {
    setGlobalSettings({
      ...globalSettings,
      [e.target.name]: e.target.type === "checkbox"
        ? e.target.checked.toString()
        : e.target.value
    });
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await updateGlobalSettingsAPI(globalSettings);
      setGlobalSettings(response);
      setOpenNotify(true);
      setLoading(false);
    } catch (err) {
      setGlobalSettings(err);
      setLoading(false);
      setErrors(err);
      setOpenNotify(true);
    }
  };

  const closeNotify = () => {
    setOpenNotify(false);
  };

  return (
    <>
      <Navbar />

      <div className="min-h-full flex justify-center items-center bg-black text-white container">
        <div className="create-user container">
          <div className="flex flex-col text-center heading">
            <h3>Global Settings</h3>
          </div>
          <div className="form-container">
            <TextField
              id="tcnAdminEndpoint"
              label="TCN Admin Endpoint"
              name="tcnAdminEndpoint"
              style={{ paddingBottom: 20 }}
              onChange={updateGlobalSetting}
              value={globalSettings?.tcnAdminEndpoint}
              InputLabelProps={{ shrink: Boolean(globalSettings?.tcnAdminEndpoint) }}
            />

            <TextField
              id="tcnAdminToken"
              label="TCN Admin Token"
              name="tcnAdminToken"
              style={{ paddingBottom: 20 }}
              onChange={updateGlobalSetting}
              value={globalSettings?.tcnAdminToken}
              InputLabelProps={{ shrink: Boolean(globalSettings?.tcnAdminToken) }}
            />

            <TextField
              id="awsAccessKey"
              label="AWS Access Key"
              name="awsAccessKey"
              style={{ paddingBottom: 20 }}
              onChange={updateGlobalSetting}
              value={globalSettings?.awsAccessKey}
              InputLabelProps={{ shrink: Boolean(globalSettings?.awsAccessKey) }}
            />

            <TextField
              id="awsSecretKey"
              label="AWS Secret Key"
              name="awsSecretKey"
              style={{ paddingBottom: 20 }}
              onChange={updateGlobalSetting}
              value={globalSettings?.awsSecretKey}
              InputLabelProps={{ shrink: Boolean(globalSettings?.awsSecretKey) }}
            />

            <TextField
              id="awsRegion"
              label="AWS Region"
              name="awsRegion"
              style={{ paddingBottom: 20 }}
              onChange={updateGlobalSetting}
              value={globalSettings?.awsRegion}
              InputLabelProps={{ shrink: Boolean(globalSettings?.awsRegion) }}
            />

            <TextField
              id="floatInvoiceRequestEmail"
              label="Float Invoice Request Email Address"
              name="floatInvoiceRequestEmail"
              style={{ paddingBottom: 20 }}
              onChange={updateGlobalSetting}
              value={globalSettings?.floatInvoiceRequestEmail}
              InputLabelProps={{ shrink: Boolean(globalSettings?.floatInvoiceRequestEmail) }}
            />

            <TextField
              id="autoDisableInactiveUsersDays"
              label="Auto Disable Inactive Users Days"
              name="autoDisableInactiveUsersDays"
              style={{ paddingBottom: 20 }}
              onChange={updateGlobalSetting}
              value={globalSettings?.autoDisableInactiveUsersDays}
              InputLabelProps={{ shrink: Boolean(globalSettings?.autoDisableInactiveUsersDays) }}
              helperText="Number of days since last login before a user is automatically disabled"
            />

            <TextField
              id="authTokenExpiry"
              label="Authentication Token Expiry In Hours"
              name="authTokenExpiry"
              type="number"
              style={{ paddingBottom: 20 }}
              onChange={updateGlobalSetting}
              value={globalSettings?.authTokenExpiry}
              InputLabelProps={{ shrink: Boolean(globalSettings?.authTokenExpiry) }}
            />

            <FormControlLabel
              control={<Checkbox checked={globalSettings?.autoDisableInactiveUsersEnabled === "true"} onChange={updateGlobalSetting} name="autoDisableInactiveUsersEnabled" />}
              label="Auto Disable Inactive Users Enabled"
              className="mui-checkbox"
            />

            <div className="flex justify-center">
              <Button
                className="button"
                onClick={handleSave}
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            </div>
          </div>

        </div>
      </div>

      <Footer />

      <Notify
        open={openNotify}
        onClose={closeNotify}
        errors={errors}
        successMessage="Settings Updated Sucessfully!"
      />
      <Loader loading={loading} />
    </>
  );
};

export default GlobalSettings;